import { Component, EventEmitter, inject, Input, OnInit, Output, SimpleChanges, OnChanges, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { LoadService } from 'src/app/core/services/load.service';
import { SesionService } from 'src/app/core/services/sesion.service';
import { BcConectaCreditos365Form, Creditos365Request } from './formsCredit365.interface';
import { ConnectOrchestratorService } from '../services/connect-orchestrator.service';
import { CookieService } from 'ngx-cookie-service';
import { BrokerService } from 'src/app/core/services/broker.service';
import { UtilitiesService } from 'src/app/core/services/utilities.service';
import { OfferService } from 'src/app/core/services/offer.service';
import { Router } from '@angular/router';
import { FingerPrintService } from '../services/finger-print.service';
import { ConnectMessagePageData } from '../interfaces/connect-message-page-model.interface';
import { GENERIC_ERROR_MESSAGE } from '../constants/connect-message-page-data';
@Component({
  selector: 'app-bc-conecta-creditos365',
  templateUrl: './bc-conecta-creditos365.component.html',
  styleUrls: ['./bc-conecta-creditos365.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BcConectaCreditos365Component implements OnInit, OnChanges {


  @Input() currentStep = 1;
  @Input() totalSteps = 3;
  @Output() requestNext = new EventEmitter<void>();
  @Output() requestPrev = new EventEmitter<void>();
  @Output() requestCancel = new EventEmitter<void>();
  @Output() requestSubmit = new EventEmitter<any>();
  @Output() dirtyChange = new EventEmitter<boolean>();
  @Output() requestMessagePage = new EventEmitter<ConnectMessagePageData>();
  @Output() requestEnableAbandonmentProcess = new EventEmitter<boolean>();

  public utilities: UtilitiesService = inject(UtilitiesService);
  public offer: OfferService = inject(OfferService);
  public cookieService: CookieService = inject(CookieService);

  public loadingResult: boolean = false;
  public resultSuccess: boolean = false;
  public showResult: boolean = false;
  public cities!: Array<any>;
  public credit365Cities: Array<{ COD_DEP: string; COD_MUN: string; NAME_DEP: string; NAME_MUN: string }> = [];
  public listCitiesByDepartment: { label: string; value: string; codMun: string }[] = [];
  public departments: { label: string; value: string; code: string }[] = [];
  public readonly MIN_AMOUNT = 100000;
  public readonly MAX_AMOUNT = 1500000;
  public disbursementUrl: string = '';

  public maxDate: Date = (() => {
    const d = new Date();
    d.setFullYear(d.getFullYear() - 19);
    return d;
  })();

  public today: Date = new Date();

  public listAdditionalContact: { label: string; value: string }[] = [
    { label: 'Madre', value: 'mother' },
    { label: 'Padre', value: 'father' },
    { label: 'Hermano/a', value: 'brother' },
    { label: 'Abuelo/a', value: 'grandfather' },
    { label: 'Cónyuge', value: 'spouse' },
    { label: 'Hijo/a', value: 'son' },
  ];

  public zones: { label: string; value: string }[] = [
    { label: 'Zona urbana', value: 'urban' },
    { label: 'Zona rural', value: 'rural' },
  ];

  public listAcademicLevel: { label: string; value: string }[] = [
    { label: 'Ninguno', value: 'none' },
    { label: 'Primaria', value: 'primary' },
    { label: 'Bachillerato', value: 'bachelor' },
    { label: 'Tecnólogo', value: 'technological' },
    { label: 'Universitario', value: 'university' },
    { label: 'Posgrado', value: 'postgraduate' },
  ];

  public listOccupation: { label: string; value: string }[] = [
    { label: 'Educación', value: 'education' },
    { label: 'Salud', value: 'healthcare' },
    { label: 'Ingeniería', value: 'engineering' },
    { label: 'Administración', value: 'administration' },
    { label: 'Contabilidad', value: 'accounting' },
    { label: 'Tecnología de la Información', value: 'it' },
    { label: 'Derecho', value: 'law' },
    { label: 'Mercadeo y Publicidad', value: 'marketing' },
    { label: 'Servicios Generales', value: 'general_services' },
    { label: 'Desempleado', value: 'unemployed' },
    { label: 'Estudiante', value: 'student' },
    { label: 'Independiente', value: 'contractor' },
    { label: 'Empleado', value: 'employee' },
    { label: 'Pensionado', value: 'pensioner' },
    { label: 'Otro', value: 'other' },
  ];

  public listBanks: { label: string; value: string, bankCode: string }[] = [
    { label: 'Bancolombia', value: 'bancolombia', bankCode: '1007' },
    { label: 'Daviplata', value: 'daviplata', bankCode: '1551' },
    { label: 'Banco JP Morgan Colombia', value: 'banco_jp_morgan_colombia', bankCode: '1071' },
    { label: 'BNP Paribas', value: 'bnp_paribas', bankCode: '0' },
    { label: 'Banco Agrario de Colombia', value: 'bco_agrario_bi_lletera_digit', bankCode: '1040' },
    { label: 'Banco AV Villas', value: 'bco_avvillas', bankCode: '1052' },
    { label: 'Banco BBVA', value: 'bbva_colombia', bankCode: '1013' },
    { label: 'Banco BCSC', value: 'banco_bcsc', bankCode: '1032' },
    { label: 'Banco Citibank', value: 'banco_citibank', bankCode: '1009' },
    { label: 'Banco Coopcentral', value: 'banco_coopcentral', bankCode: '1066' },
    { label: 'Banco Davivienda', value: 'banco_davivienda', bankCode: '1051' },
    { label: 'Banco de Bogotá', value: 'bco_de_bogota', bankCode: '1001' },
    { label: 'Banco de la República', value: 'banco_de_la_republica', bankCode: '0' },
    { label: 'Banco de Occidente', value: 'banco_de_occidente', bankCode: '1023' },
    { label: 'Banco Falabella', value: 'b_falabella_ahorros', bankCode: '1062' },
    { label: 'Banco Finandina', value: 'banco_finandina', bankCode: '1063' },
    { label: 'Banco GNB Sudameris', value: 'banco_gnb_sudameris', bankCode: '1012' },
    { label: 'Banco Itaú Corpbanca Colombia', value: 'itau_corpbanca_ahorros', bankCode: '1006' },
    { label: 'Banco Scotiabank Colpatria', value: 'scotiabank_colpatria', bankCode: '1019' },
    { label: 'Banco Pichincha', value: 'banco_pichincha_sa', bankCode: '1060' },
    { label: 'Banco Popular', value: 'bco_popular', bankCode: '1002' },
    { label: 'Bancoldex', value: 'bancoldex', bankCode: '1031' },
    { label: 'Banco Santander de Negocios', value: 'banco_santander_de_negocios', bankCode: '1065' },
    { label: 'Banco Caja Social', value: 'banco_caja_social', bankCode: '1032' },
    { label: 'Credifinanciera', value: 'credifinanciera', bankCode: '1558' },
    { label: 'Bancamía', value: 'bancamia', bankCode: '1059' },
    { label: 'Banco W', value: 'banco_w', bankCode: '1053' },
    { label: 'Bancoomeva', value: 'bancoomeva_c_ahorro', bankCode: '1061' },
    { label: 'Banco Nequi', value: 'bancoomeva_nequi', bankCode: '1507' },
  ];

  private readonly ALL_ACCOUNT_TYPES: { label: string; value: string }[] = [
    { label: 'Cuenta de ahorros', value: 'savings' },
    { label: 'Cuenta corriente', value: 'checking' },
    { label: 'Depósito electrónico', value: 'electronic_deposit' }
  ];

  private readonly DIGITAL_WALLET_BANKS = new Set(['daviplata', 'bancoomeva_nequi']);

  public listAccountType: { label: string; value: string }[] = [
    { label: 'Cuenta de ahorros', value: 'savings' },
    { label: 'Cuenta corriente', value: 'checking' },
    { label: 'Depósito electrónico', value: 'electronic_deposit' }
  ];

  public selectAdditionalContact: { label: string; value: string } | string = '';
  public selectAcademicLevel: { label: string; value: string } | string = '';
  public selectOccupation: { label: string; value: string } | string = '';
  public selectYourBank: { label: string; value: string; bankCode: string } = {
    label: '',
    value: '',
    bankCode: ''
  };
  public selectAccountType: { label: string; value: string } | string = '';
  public selectZone: string = '';
  public selectDepartment: string = '';
  public departmentCode: string = '';
  public cityDaneMun: string = '';

  private fb = inject(FormBuilder);

  public form = this.fb.group({
    step1: this.fb.group({
      birthDate: [null as BcConectaCreditos365Form['step1']['birthDate'] | null, [Validators.required]],
      expeditionDate: [null as BcConectaCreditos365Form['step1']['expeditionDate'] | null, [Validators.required]],
      department: ['' as BcConectaCreditos365Form['step1']['department'], [Validators.required]],
      city: ['' as BcConectaCreditos365Form['step1']['city'], [Validators.required]],
      neighborhood: ['' as BcConectaCreditos365Form['step1']['neighborhood'], [Validators.required]],
      zone: ['' as BcConectaCreditos365Form['step1']['zone'], [Validators.required]],
      address: ['' as BcConectaCreditos365Form['step1']['address'], [Validators.required]],
      gender: ['' as BcConectaCreditos365Form['step1']['gender'], [Validators.required]],
      studyLevelCode: ['' as BcConectaCreditos365Form['step1']['studyLevelCode'], [Validators.required]],
      additionalContact: ['' as BcConectaCreditos365Form['step1']['additionalContact'], [Validators.required]],
      numberContact: ['' as BcConectaCreditos365Form['step1']['numberContact'], [Validators.required]],
    }),
    step2: this.fb.group({
      amount: [
        null as BcConectaCreditos365Form['step2']['amount'] | null,
        [Validators.required, Validators.min(this.MIN_AMOUNT), Validators.max(this.MAX_AMOUNT), Validators.pattern('^[0-9]*$')]
      ],
      income: [null as BcConectaCreditos365Form['step2']['income'] | null, [Validators.required, Validators.min(1), Validators.pattern('^[0-9]*$')]],
      occupationCode: ['' as BcConectaCreditos365Form['step2']['occupationCode'], [Validators.required]],
      bankCode: ['' as BcConectaCreditos365Form['step2']['bankCode'], [Validators.required]],
      accountType: ['' as BcConectaCreditos365Form['step2']['accountType'], [Validators.required]],
      accountNumber: ['' as BcConectaCreditos365Form['step2']['accountNumber'], [Validators.required, Validators.minLength(9)]],
      allyTermsAccepted: [false as BcConectaCreditos365Form['step2']['allyTermsAccepted'], [Validators.requiredTrue]],
    }),
  });

  constructor(
    public sesion: SesionService,
    public load: LoadService,
    private broker: BrokerService,
    private connectOrchestrator: ConnectOrchestratorService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private fingerPrintService: FingerPrintService
  ) { }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['currentStep'] && !changes['currentStep'].firstChange) {
      this.cdr.detectChanges();
    }
  }

  ngOnInit(): void {
    this.getDepartment();
    this.getCitiesCredit365();

    this.dirtyChange.emit(this.form.dirty);
    this.form.valueChanges.subscribe(() => {
      this.dirtyChange.emit(this.form.dirty);
    });
  }

  nextStep(): void {
    if (this.currentStep === 2) {
      this.form.controls.step2.markAllAsTouched();
      if (!this.form.controls.step2.valid) {
        return;
      }
    }
    this.requestNext.emit();
  }

  prevStep(): void {
    this.requestCancel.emit();
  }

  cancel(): void {
    this.requestCancel.emit();
  }

  setAdditionalContact(value: string): void {
    this.selectAdditionalContact = value;
    this.form.controls.step1.controls.additionalContact.setValue(value);
  }

  setAcademicLevel(value: { label: string; value: string }): void {
    this.selectAcademicLevel = value;
    this.form.controls.step1.controls.studyLevelCode.setValue(value.value);
  }

  setOccupation(value: { label: string; value: string }): void {
    this.selectOccupation = value;
    this.form.controls.step2.controls.occupationCode.setValue(value.value);
  }

  setSelectYourBank(value: { label: string; value: string; bankCode: string }): void {
    this.selectYourBank = value;
    this.form.controls.step2.controls.bankCode.setValue(value.bankCode);

    if (this.DIGITAL_WALLET_BANKS.has(value.value)) {
      // Nequi y Daviplata solo admiten depósito electrónico
      const electronicDeposit = { label: 'Depósito electrónico', value: 'electronic_deposit' };
      this.listAccountType = [electronicDeposit];
      this.selectAccountType = electronicDeposit;
      this.form.controls.step2.controls.accountType.setValue('electronic_deposit');
      this.form.controls.step2.controls.accountType.markAsTouched();
    } else {
      // Banco convencional: restaurar todas las opciones y limpiar selección anterior
      this.listAccountType = [...this.ALL_ACCOUNT_TYPES];
      this.selectAccountType = '';
      this.form.controls.step2.controls.accountType.setValue('');
    }
  }

  setAccountType(value: { label: string; value: string }): void {
    this.selectAccountType = value;
    this.form.controls.step2.controls.accountType.setValue(value.value);
  }

  setGender(value: 'F' | 'M'): void {
    this.form.controls.step1.controls.gender.setValue(value);
    this.form.controls.step1.controls.gender.markAsTouched();
  }

  setZone(value: string): void {
    this.selectZone = value;
    this.form.controls.step1.controls.zone.setValue(value);
  }

  setDepartment(department: { label: string; value: string; code: string }): void {
    this.selectDepartment = department.value;
    this.departmentCode = department.code;
    this.form.controls.step1.controls.department.setValue(department.value);
    this.form.controls.step1.controls.city.setValue('');
    this.getCitiesByDepartment(department.code);
  }

  setCity(city: { label: string; value: string; codMun: string }): void {
    this.cityDaneMun = city.codMun;
    this.form.controls.step1.controls.city.setValue(city.value);
  }

  formatBirthDateInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value.replace(/\D/g, '');

    if (value.length >= 2) {
      value = value.substring(0, 2) + '/' + value.substring(2);
    }
    if (value.length >= 5) {
      value = value.substring(0, 5) + '/' + value.substring(5, 9);
    }

    input.value = value;

    const control = this.form.controls.step1.controls.birthDate;

    if (value.length === 10) {
      const parts = value.split('/');
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const year = parseInt(parts[2], 10);

      const date = new Date(year, month, day);

      const isValidDate = date.getFullYear() === year && date.getMonth() === month && date.getDate() === day;

      if (isValidDate && date <= this.maxDate) {
        control.setValue(date);
        control.markAsTouched();
      } else {
        control.setValue(null);
        input.value = '';
      }
    } else {
      control.setValue(null);
    }
  }

  getDepartment() {
    this.broker.getCities().subscribe((data: any) => {
      this.cities = data;

      const departmentMap = new Map<string, string>();
      this.cities.forEach((obj: any) => {
        if (typeof obj.NAME_DEP === 'string' && obj.NAME_DEP.trim() !== '' && !departmentMap.has(obj.NAME_DEP)) {
          departmentMap.set(obj.NAME_DEP, obj.COD_DEP ?? '');
        }
      });

      this.departments = Array.from(departmentMap.entries())
        .map(([name, code]) => ({
          value: name,
          label: name,
          code,
        }))
        .sort((a, b) => this.compareStrings(a.label, b.label));
    });
  }

  getCitiesCredit365() {
    this.connectOrchestrator.getCitiesDaneId().subscribe((response: any) => {
      this.credit365Cities = Array.isArray(response) ? response : [];
      if (this.departmentCode) {
        this.getCitiesByDepartment(this.departmentCode);
      }
    });
  }

  compareStrings(a: any, b: any) {
    a = a.toLowerCase();
    b = b.toLowerCase();
    return (a < b) ? -1 : (a > b) ? 1 : 0;
  }

  getCitiesByDepartment(departmentCode: string) {
    if (!departmentCode) {
      this.listCitiesByDepartment = [];
      return;
    }

    this.listCitiesByDepartment = this.credit365Cities
      .filter((city) => city.COD_DEP === departmentCode)
      .map((city) => ({
        label: city.NAME_MUN,
        value: city.NAME_MUN,
        codMun: city.COD_MUN,
      }))
      .sort((a, b) => this.compareStrings(a.label, b.label));
  }

  private getRegionIdByDepartmentCode(departmentCode: string): number | null {
    const mapByDaneCode: Record<string, number> = {
      '5': 1,   // Antioquia
      '91': 2,  // Amazonas
      '81': 3,  // Arauca
      '88': 4,  // San Andres, Providencia y Santa Catalina
      '8': 5,   // Atlantico
      '11': 6,  // Bogota D.C.
      '13': 7,  // Bolivar
      '15': 8,  // Boyaca
      '17': 9,  // Caldas
      '18': 10, // Caqueta
      '85': 11, // Casanare
      '19': 12, // Cauca
      '20': 13, // Cesar
      '27': 14, // Choco
      '23': 15, // Cordoba
      '25': 16, // Cundinamarca
      '94': 17, // Guainia
      '95': 18, // Guaviare
      '41': 19, // Huila
      '44': 20, // La Guajira
      '47': 21, // Magdalena
      '50': 22, // Meta
      '52': 23, // Narino
      '54': 24, // Norte de Santander
      '86': 25, // Putumayo
      '63': 26, // Quindio
      '66': 27, // Risaralda
      '68': 28, // Santander
      '70': 29, // Sucre
      '73': 30, // Tolima
      '76': 31, // Valle del Cauca
      '97': 32, // Vaupes
      '99': 33, // Vichada
    };

    const normalizedCode = String(departmentCode || '').replace(/^0+/, '');
    return mapByDaneCode[normalizedCode] ?? null;
  }

  //metodo para construir el request con los datos del formulario y otros datos necesarios para el backend, 
  // algunos de estos datos se deben obtener de la sesión o son valores fijos.
  applyOffer(clientIpAddress: string = ''): Creditos365Request {
    let sourceOfTraffic = '';
    let campaignOfTraffic = '';
    let mediumOfTraffic = '';
    if ((Object.keys(this.utilities.utmParams).length > 0)) {
      for (const key in this.utilities.utmParams) {
        if (key.toLowerCase() == 'utm_source') {
          sourceOfTraffic = this.utilities.utmParams[key] || 'Orgánico';
        }
        if (key.toLowerCase() == 'utm_medium') {
          mediumOfTraffic = this.utilities.utmParams[key] || 'Orgánico';
        }
        if (key.toLowerCase() == 'utm_campaign') {
          campaignOfTraffic = this.utilities.utmParams[key] || 'Orgánico';
        }
      }
    }
    const step1 = this.form.controls.step1.getRawValue();
    const step2 = this.form.controls.step2.getRawValue();
    const sessionUser = this.sesion.dataUser ?? {};
    console.log('sessionUser', sessionUser);
    const fullName = String(this.sesion.nameSession ?? '').trim();
    const personalId = this.getValueByKeys(sessionUser, [
      'idNumber'
    ]);

    const phoneNumber = this.normalizePhone(this.sesion.userPhone || step1.numberContact || this.getValueByKeys(sessionUser, ['telefono', 'celular']));
    const daneId = this.cityDaneMun || this.getDaneIdByCity(step1.city ?? '');
    const monthlyIncome = step2.income ? String(step2.income) : '';
    const monthlyExpenses = step2.income ? String(Math.round(step2.income * 0.4)) : '';
    const amount = step2.amount ?? 0;
    const address = step1.address ?? '';

    return {
      idSession: String(this.sesion.sesionCookie ?? ''),
      companyId: this.offer.offerSelected.company.id,
      offerId: this.offer.offerSelected.offerId,
      amount: String(amount),
      sourceOfTraffic: sourceOfTraffic,
      campaignOfTraffic: campaignOfTraffic,
      mediumOfTraffic: mediumOfTraffic,
      conecta: {
        birthDate: step1.birthDate ? this.formatDate(step1.birthDate) : '',
        gender: step1.gender ?? '',
        expeditionDate: step1.expeditionDate ? this.formatDate(step1.expeditionDate) : '',
        phoneNumber,
        amount,
        idCountry: 'CO',
        allyTermsAccepted: step2.allyTermsAccepted ?? false,
        dataProcessingPolicyAccepted: step2.allyTermsAccepted ?? false,
        occupationCode: step2.occupationCode ?? '',
        studyLevelCode: step1.studyLevelCode ?? '',
        monthlyIncome,
        monthlyExpenses,
        departmentCode: this.departmentCode,
        daneId,
        address,
        addressDetail: this.parseAddressDetail(address),
        bankCode: step2.bankCode ?? '',
        bankAccountNumber: step2.accountNumber ?? '',
        accountType: step2.accountType ?? '',
        clientIpAddress
      }
    };
  }

  confirmRequest(): void {
    this.load.isInProcess = true;
    this.disbursementUrl = '';
    this.fingerPrintService.getClientRequestHeaders().subscribe(headers => {
      if (!this.isValidIp(headers.clientIpAddress)) {
        this.load.isInProcess = false;
        return;
      }
      this.updateInfo(() => {
        const request = this.applyOffer(headers.clientIpAddress);
        this.broker.aplicarOferta(request).subscribe({
          next: (result: any) => {
            if (result.responseConecta.data === null || result.responseConecta.data === undefined) {
              this.resultSuccess = false;
              this.showResult = true;
              this.load.isInProcess = false;
              this.load.isConectaFail = true;
              this.load.isConectaRejected = false;
              this.load.imgBcConectaDesktop = this.load.imgsBcConecta.d_fail;
              this.load.imgBcConectaMobile = this.load.imgsBcConecta.m_fail;
              this.requestMessagePage.emit(GENERIC_ERROR_MESSAGE);
              return;
            }
            const dataObj = typeof result.responseConecta.data === 'string'
              ? JSON.parse(result.responseConecta.data)
              : result.responseConecta.data;
            const statusData = dataObj.data || dataObj;
            this.disbursementUrl = typeof statusData?.urlRedirect === 'string' ? statusData.urlRedirect.trim() : '';
            const status = statusData.status;

            switch (status) {
              case 'RECEIVED':
                this.resultSuccess = true;
                this.showResult = true;
                this.load.isInProcess = false;
                break;

              case 'ALREADY_REGISTERED':
                this.resultSuccess = true;
                this.showResult = true;
                this.load.isInProcess = false;
                break;

              case 'REGISTRATION_DECLINED':
                this.resultSuccess = false;
                this.showResult = true;
                this.load.isInProcess = false;
                this.load.isConectaFail = true;
                this.load.isConectaRejected = true;
                this.load.imgBcConectaDesktop = this.load.imgsBcConecta.d_fail;
                this.load.imgBcConectaMobile = this.load.imgsBcConecta.m_fail;
                this.requestMessagePage.emit(GENERIC_ERROR_MESSAGE);
                break;

              default:
                this.resultSuccess = false;
                this.showResult = true;
                this.load.isInProcess = false;
                this.load.isConectaFail = true;
                this.load.isConectaRejected = false;
                this.load.imgBcConectaDesktop = this.load.imgsBcConecta.d_fail;
                this.load.imgBcConectaMobile = this.load.imgsBcConecta.m_fail;
                this.requestMessagePage.emit(GENERIC_ERROR_MESSAGE);
                break;
            }
          },
          error: (error: any) => {
            this.resultSuccess = false;
            this.showResult = true;
            this.load.isInProcess = false;
            this.load.isConectaFail = true;
            this.load.isConectaRejected = false;
            this.load.imgBcConectaDesktop = this.load.imgsBcConecta.d_fail;
            this.load.imgBcConectaMobile = this.load.imgsBcConecta.m_fail;
            this.requestMessagePage.emit(GENERIC_ERROR_MESSAGE);
            console.error(error);
          }
        });
      });
    });
  }

  private getValueByKeys(source: any, keys: string[]): string {
    if (!source || typeof source !== 'object') {
      return '';
    }

    for (const key of keys) {
      const directValue = source[key];
      if (directValue !== undefined && directValue !== null && String(directValue).trim() !== '') {
        return String(directValue).trim();
      }
    }

    const sourceEntries = Object.entries(source) as Array<[string, any]>;
    for (const key of keys) {
      const found = sourceEntries.find(([entryKey]) => entryKey.toLowerCase() === key.toLowerCase());
      if (found && found[1] !== undefined && found[1] !== null && String(found[1]).trim() !== '') {
        return String(found[1]).trim();
      }
    }

    return '';
  }

  private normalizePhone(rawPhone: any): string {
    const digitsOnly = String(rawPhone ?? '').replace(/\D/g, '');
    if (!digitsOnly) {
      return '';
    }
    if (digitsOnly.startsWith('57')) {
      return digitsOnly;
    }
    if (digitsOnly.length === 10) {
      return `57${digitsOnly}`;
    }
    return digitsOnly;
  }

  private isValidIp(ip: string): boolean {
    return /^(\d{1,3}\.){3}\d{1,3}$/.test(ip ?? '');
  }

  private getDaneIdByCity(cityName: string): string {
    if (!cityName || !Array.isArray(this.cities)) {
      return '';
    }

    const normalizedCity = cityName.trim().toLowerCase();
    const normalizedDepartmentCode = String(this.departmentCode || '').replace(/^0+/, '');

    const sameCityCandidates = this.cities.filter((city: any) =>
      String(city?.NAME_MUN ?? '').trim().toLowerCase() === normalizedCity
    );

    const cityByDepartment = sameCityCandidates.find((city: any) =>
      String(city?.COD_DEP ?? '').replace(/^0+/, '') === normalizedDepartmentCode
    );

    const selectedCity = cityByDepartment ?? sameCityCandidates[0];
    if (!selectedCity) {
      return '';
    }

    return String(
      selectedCity.COD_DANE ?? selectedCity.COD_MUN ?? selectedCity.DANE ?? selectedCity.ID_MUN ?? ''
    );
  }

  private parseAddressDetail(address: string): { type: string; number1: string; number2: string; number3: string; number4: string; number5: string } {
    const cleanAddress = String(address ?? '').trim();
    if (!cleanAddress) {
      return { type: '', number1: '', number2: '', number3: '', number4: '', number5: '' };
    }

    const parts = cleanAddress
      .replace(/[.,]/g, ' ')
      .split(/\s+/)
      .filter(Boolean);

    const type = parts[0] ?? '';
    const stopWords = new Set(['la', 'las', 'el', 'los', 'de', 'del']);
    const matchs = parts
      .slice(1)
      .map((part) => part.replace(/[^0-9a-zA-Z]/g, ''))
      .filter((part) => part.length > 0)
      .filter((part) => !stopWords.has(part.toLowerCase()));

    return {
      type,
      number1: matchs[0] ?? '',
      number2: matchs[1] ?? '',
      number3: matchs[2] ?? '',
      number4: matchs[3] ?? '',
      number5: matchs[4] ?? '',
    };


  }

  //  Actualiza información del perfil del usuario
  public updateInfo(onComplete?: () => void): void {
    try {
      const addressStep1 = this.form.controls.step1.controls.address.value;
      const address = String(addressStep1 ?? '').trim();
      const studyLevelCode = String(this.form.controls.step1.controls.studyLevelCode.value ?? '').trim();
      const studyLevelProfile = this.mapStudyLevelToProfile(studyLevelCode);
      const occupationCode = String(this.form.controls.step2.controls.occupationCode.value ?? '').trim();
      const occupationProfile = this.mapOccupationToProfile(occupationCode);
      const workActivityProfile = this.mapWorkActivityToProfile(occupationCode);

      const bodyUpdateProfile: Record<string, any> = {
        idSession: this.cookieService.get('IDSESSIONMDC'),
        cellPhone: this.sesion.userPhone,
        address: address,
        country: 'CO'
      };
      if (studyLevelProfile !== null) {
        bodyUpdateProfile['studyLevelCode'] = studyLevelProfile;
      }
      if (occupationProfile !== null) {
        bodyUpdateProfile['occupationCode'] = occupationProfile;
      }
      if (workActivityProfile !== null) {
        bodyUpdateProfile['workActivityCode'] = workActivityProfile;
      }

      this.broker.updateInfo(bodyUpdateProfile).subscribe({
        next: (result: any) => {
          onComplete?.();
        },
        error: (error: any) => {
          console.error('Error al actualizar el perfil:', error);
          onComplete?.();
        }
      });
    } catch (error) {
      console.error('Error en updateInfo:', error);
      onComplete?.();
    }
  }

  // homologa el nivel educativo entre el aliado creditos365 Y Perfil MIDC 
  private mapStudyLevelToProfile(studyLevelCode: string): number | null {
    const map: Record<string, number> = {
      // Por string (valor de listAcademicLevel)
      primary: 2,
      bachelor: 3,
      technological: 4,
      university: 5,
      postgraduate: 6,
      // Por código numérico del perfil (por si el valor ya llega como número)
      '2': 2,
      '3': 3,
      '4': 4,
      '5': 5,
      '6': 6,
    };

    const result = map[studyLevelCode] ?? null;
    return result;
  }

  // Homologa la situación laboral de Créditos 365 al código que espera el perfil MDC
  private mapOccupationToProfile(occupationCode: string): number | null {
    const normalizedOccupation = String(occupationCode ?? '').trim().toLowerCase();

    const map: Record<string, number> = {
      contractor: 3,
      contract: 10,
      unemployed: 7,
      student: 1,
      pensioner: 4,
      other: 10,
      education: 1,
      pensionado: 4,
      desempleado: 7,
      estudiante: 1,
      empresario: 10,
    };

    return map[normalizedOccupation] ?? null;
  }

  // Homologa actividad económica de Créditos 365 al código de perfil MDC
  private mapWorkActivityToProfile(occupationCode: string): number | null {
    const normalizedOccupation = String(occupationCode ?? '').trim().toLowerCase();

    const map: Record<string, number> = {
      engineering: 18,
      it: 18,
      healthcare: 15,
      marketing: 12,
      law: 10,
      accounting: 9,
      education: 8,
      administration: 2,
      unemployed: 1,
    };

    return map[normalizedOccupation] ?? null;
  }

  private formatDate(date: Date): string {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }

  public get amountControl() {
    return this.form.controls.step2.controls.amount;
  }

  public get incomeControl() {
    return this.form.controls.step2.controls.income;
  }

  public onAmountInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const digitsOnly = input.value.replace(/\D/g, '');

    if (!digitsOnly) {
      this.amountControl.setValue(null);
      input.value = '';
      return;
    }

    const numericValue = Number(digitsOnly);
    this.amountControl.setValue(numericValue);
    this.amountControl.markAsDirty();
    input.value = numericValue.toLocaleString('es-CO');
  }

  public onCreditAmountBlur(): void {
    this.amountControl.markAsTouched();
  }

  public onIncomeInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const digitsOnly = input.value.replace(/\D/g, '');

    if (!digitsOnly) {
      this.incomeControl.setValue(null);
      input.value = '';
      return;
    }

    const numericValue = Number(digitsOnly);
    this.incomeControl.setValue(numericValue);
    this.incomeControl.markAsDirty();
    input.value = numericValue.toLocaleString('es-CO');
  }

  public onIncomeBlur(): void {
    this.incomeControl.markAsTouched();
  }

  public onNumberContactInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const digitsOnly = input.value.replace(/\D/g, '');
    input.value = digitsOnly;
    this.form.controls.step1.controls.numberContact.setValue(digitsOnly);
    this.form.controls.step1.controls.numberContact.markAsDirty();
  }

  public onAccountNumberInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const digitsOnly = input.value.replace(/\D/g, '');
    input.value = digitsOnly;
    this.form.controls.step2.controls.accountNumber.setValue(digitsOnly);
    this.form.controls.step2.controls.accountNumber.markAsDirty();
  }

  public get accountNumberLength(): number {
    return String(this.form.controls.step2.controls.accountNumber.value ?? '').length;
  }

  public get canContinueStep1(): boolean {
    return this.form.controls.step1.valid;
  }
  public get canContinueStep2(): boolean {
    return this.form.controls.step2.valid && !!this.form.controls.step2.controls.allyTermsAccepted.value;
  }

  public goDisbursement(): void {
    if (!this.disbursementUrl) {
      console.warn('No se recibio urlRedirect para desembolso');
      return;
    }

    window.open(
      this.disbursementUrl,
      '_blank',
      'noopener,noreferrer'
    );

    setTimeout(() => {
      this.router.navigate(['/ofertas']);
    }, 3000);
  }

  registerAbandonment(reason: string): void {
    let utmSource = 'Orgánico';
    let utmMedium = 'Orgánico';
    let utmCampaign = 'Orgánico';
    if (Object.keys(this.utilities.utmParams).length > 0) {
      for (const key in this.utilities.utmParams) {
        if (key.toLowerCase() === 'utm_source') { utmSource = this.utilities.utmParams[key] || 'Orgánico'; }
        if (key.toLowerCase() === 'utm_medium') { utmMedium = this.utilities.utmParams[key] || 'Orgánico'; }
        if (key.toLowerCase() === 'utm_campaign') { utmCampaign = this.utilities.utmParams[key] || 'Orgánico'; }
      }
    }

    const inputsComplete: Record<string, any> = {};
    const step1Values = this.form.controls.step1.getRawValue();
    for (const [key, value] of Object.entries(step1Values)) {
      if (value !== null && value !== '') {
        inputsComplete[key] = '*';
      }
    }
    if (this.currentStep >= 2) {
      const step2Values = this.form.controls.step2.getRawValue();
      for (const [key, value] of Object.entries(step2Values)) {
        if (value !== null && value !== '') {
          inputsComplete[key] = '*';
        }
      }
    }

    const body = {
      idSession: String(this.sesion.sesionCookie ?? ''),
      utmSource,
      utmMedium,
      utmCampaign,
      nit: String(this.offer.offerSelected?.company?.nit ?? this.offer.offerSelected?.company?.id ?? ''),
      step: this.currentStep,
      reason,
      idOffer: this.offer.offerSelected?.offerId,
      channel: 'WEB',
      inputsComplete,
    };

    this.connectOrchestrator.registerOfferAbandonment(body).subscribe({
      error: (err: any) => console.error('Error al registrar abandono:', err),
    });
  }
}
